import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useLegalEntityOptions = ({ appConfiguration, loadAll, settings }) => {

    const { legalEntitySelector } = appConfiguration || {}
    const { canSeeAllButton } = legalEntitySelector || {}

    const { t } = useTranslation()

    const [legalEntityOptions, setLegalEntityOptions] = useState()

    useEffect(() => {
        if (!legalEntityOptions && settings) {
            const onError = () => setLegalEntityOptions([])
            const onSuccess = (data) => {
                const { items } = data || {}
                const { data: options } = items || {}
                const optionAll = canSeeAllButton ? [{ id: 'all', name: t('all') }] : []
                setLegalEntityOptions([...optionAll, ...options] || [])
            }
            loadAll().then(onSuccess).catch(onError)
        }
    }, [legalEntityOptions, settings])

    return { legalEntityOptions, setLegalEntityOptions }
}